module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "persistent": "",
      "transition": "fade-transition",
      "fullscreen": "",
      "no-click-animation": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "modal-content"
  }, [_c('v-toolbar', {
    attrs: {
      "color": "#3F3FFF",
      "elevation": 1
    }
  }, [_c('v-toolbar-title', [_c('v-text-field', {
    staticClass: "pairing-list-title-input col-12 mt-3 pr-2 float-left",
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "label": "Enter Title",
      "hide-details": ""
    },
    model: {
      value: (_vm.infListTitle),
      callback: function($$v) {
        _vm.infListTitle = $$v
      },
      expression: "infListTitle"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-row', {
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('v-col', {
    staticClass: "col-md-5 col-xs-5",
    attrs: {
      "align": "center"
    }
  }, [_c('h3', {
    staticClass: "mb-1"
  }, [_vm._v("Find influencers manually")]), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.HANDLE) ? _c('v-text-field', {
    staticClass: "col-8 mt-3 pr-2 float-left",
    attrs: {
      "label": _vm.searchInfluencer === 'Youtube' ? 'Enter Handle' : 'Enter handle',
      "hide-details": "",
      "outlined": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchManually(_vm.searchType)
      }
    },
    model: {
      value: (_vm.igHandle),
      callback: function($$v) {
        _vm.igHandle = $$v
      },
      expression: "igHandle"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.HANDLE) ? _c('v-select', {
    staticClass: "col-4 mt-3 float-left",
    attrs: {
      "items": _vm.searchInfluencerTypes,
      "outlined": "",
      "attach": ""
    },
    model: {
      value: (_vm.searchInfluencer),
      callback: function($$v) {
        _vm.searchInfluencer = $$v
      },
      expression: "searchInfluencer"
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "igBulkHandle",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xlsx",
      "id": "igBulkHandle"
    },
    on: {
      "change": _vm.igHandleBulkUpload
    }
  }), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.KEYWORD) ? _c('k-influencer-search-box', {
    attrs: {
      "search": _vm.searchKeywordAction
    },
    on: {
      "result": _vm.resultFromSearchKeyword
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchType !== _vm.SearchTypeEnum.BULKUPLOAD) ? _c('v-btn', {
    staticClass: "float-right mt-2",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.searchManually(_vm.searchType)
      }
    }
  }, [_vm._v("Search")]) : _vm._e(), _vm._v(" "), (_vm.searchType === _vm.SearchTypeEnum.KEYWORD) ? _c('v-btn', {
    staticClass: "mt-2 float-right",
    attrs: {
      "disabled": !_vm.historySearchResult,
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.showResult(_vm.historySearchResult)
      }
    }
  }, [_vm._v("View search results")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "-45px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "7"
    }
  })], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "mt-3",
    attrs: {
      "cols": "12",
      "sm": "7",
      "md": "7",
      "lg": "7"
    }
  }, [_c('div', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "5"
    }
  }, [(_vm.items && _vm.items.length > 0) ? _c('download-excel', {
    staticClass: "btn btn-default",
    attrs: {
      "data": _vm.items,
      "fields": _vm.json_fields,
      "worksheet": "Creators",
      "name": "creator_lists.xls"
    }
  }, [_vm._v("Download Excel")]) : _vm._e(), _vm._v(" "), (_vm.actionSelected.length > 0 && !_vm.disableLockedCOGS) ? _c('v-btn', {
    attrs: {
      "color": "error",
      "small": ""
    },
    on: {
      "click": _vm.confirmDelete
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("delete")]), _vm._v(" Delete")], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "5",
      "md": "5",
      "lg": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1 page__table",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "item-key": "dataTableKey",
      "search": _vm.searchFilter,
      "items-per-page": 20,
      "no-data-text": 'Empty list',
      "show-select": "",
      "single-select": false
    },
    on: {
      "toggle-select-all": _vm.selectAllPairings
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return _vm._l((props.items), function(item, parentIndex) {
          return _c('tr', {
            key: item.instagram,
            class: {
              'danger': !item.success && !item.isLoading
            }
          }, [_c('td', {
            staticStyle: {
              "min-width": "100px",
              "padding": "0 14px!important"
            }
          }, [_c('v-checkbox', {
            staticClass: "multi-select-checkbox",
            staticStyle: {
              "padding-left": "20px"
            },
            attrs: {
              "label": "",
              "color": "grey darken-2"
            },
            on: {
              "change": _vm.actionSelectChange
            },
            model: {
              value: (item.isDelete),
              callback: function($$v) {
                _vm.$set(item, "isDelete", $$v)
              },
              expression: "item.isDelete"
            }
          })], 1), _vm._v(" "), (_vm.displayFields('influencer')) ? _c('td', {
            staticStyle: {
              "min-width": "200px",
              "max-width": "200px"
            },
            attrs: {
              "align": "center"
            }
          }, [_c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": item.platform === 'tiktok',
              "isInstagram": item.platform === 'instagram',
              "isFacebook": item.platform === 'facebook',
              "isYoutube": item.platform === 'youtube',
              "isXiaohongshu": item.platform === 'xiaohongshu',
              "tiktokHandle": item.userHandle,
              "instagramHandle": item.userHandle,
              "facebookHandle": item.userHandle,
              "youtubeHandle": item.userHandle,
              "xiaohongshuHandle": item.xhsID,
              "xiaohongshuFullName": item.fullName,
              "youtubeURL": item.url
            }
          }), _vm._v(" "), (item.multipleInfs && item.multipleInfs.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "padding": "0",
                    "margin-left": "-9px",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        staticClass: "ml-2",
                        attrs: {
                          "color": "warning",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((item.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i,
              attrs: {
                "link": ""
              },
              on: {
                "click": function($event) {
                  return _vm.changePlatform(obj, i)
                }
              }
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e(), _vm._v(" "), (!item.isLoading && item.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "green"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("done")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _vm._e(), _vm._v(" "), (!item.isLoading && !item.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  attrs: {
                    "color": "red"
                  },
                  on: {
                    "click": true
                  }
                }, on), [_vm._v("cancel")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Not in IMS")])]) : _vm._e(), _vm._v(" "), (item.socialDataErrMessage) ? _c('p', {
            staticClass: "text-danger mb-0"
          }, [_vm._v("(" + _vm._s(item.socialDataErrMessage) + ")")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.remarkEdit === false && _vm.displayFields('remark')) ? _c('td', {
            staticStyle: {
              "min-width": "200px"
            },
            attrs: {
              "align": "center"
            },
            on: {
              "click": function($event) {
                return _vm.openEditItem(item.pairingID, 'remark')
              }
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": "",
              "max-width": "300px"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_c('p', {
                  staticClass: "remark-text"
                }, [_vm._v(_vm._s(item.remarks || '-'))])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.renderRemark(item.remarks))
            }
          })])], 1) : _vm._e(), _vm._v(" "), (item.remarkEdit === true) ? _c('td', {
            staticClass: "editing",
            attrs: {
              "align": "center"
            }
          }, [_c('v-textarea', {
            staticClass: "ma-3",
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "hide-details": "",
              "dense": "",
              "outlined": ""
            },
            model: {
              value: (item.remarks),
              callback: function($$v) {
                _vm.$set(item, "remarks", $$v)
              },
              expression: "item.remarks"
            }
          })], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('gender')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(!item.genderEdit) ? _c('div', [(!item.genderEdit) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.gender || '-'))]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayFields('ageGroup')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(!item.ageGroupEdit) ? _c('div', [_c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.age_group || '-'))])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.displayFields('audAgeGroup')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('div', [((!item.audAges || (Array.isArray(item.audAges) && item.audAges.length === 0)) && (!item.topAudAges || (Array.isArray(item.topAudAges) && item.topAudAges.length === 0))) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._e(), _vm._v(" "), (Array.isArray(item.audAges) && Array.isArray(item.topAudAges)) ? _c('div', [((item.audAges.length || item.topAudAges.length) && !item.audAgesEdit) ? _c('v-menu', {
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: ((item.audAges.length || item.topAudAges.length) && !item.audAgesEdit),
                    expression: "(item.audAges.length || item.topAudAges.length) && !item.audAgesEdit"
                  }],
                  staticClass: "multi-select-more-btn ma-2",
                  attrs: {
                    "id": 'btnMore_' + parentIndex,
                    "x-small": "",
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [(item.topAudAges && item.topAudAges.length) ? _c('span', [_vm._v("\n                                      " + _vm._s(item.topAudAges ? item.topAudAges[0] : '-') + "\n                                    ")]) : _c('span', [_vm._v("\n                                      " + _vm._s(item.audAges.length ? item.audAges[0].code : '-') + "\n                                    ")])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Aud. Age Group (Majority)")]), _vm._v(" "), (item.audAgesDisplay) ? _c('div', [_c('v-divider'), _vm._v(" "), _vm._l((item.audAgesDisplay), function(audAge, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(audAge.code))]), _vm._v(" "), (audAge.weight) ? _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((audAge.weight * 100).toFixed(2)) + "%)")]) : _vm._e()], 1)
          })], 2) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.audAges), function(age, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(age.code))]), _vm._v(" "), _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((age.weight * 100).toFixed(2)) + "%)")])], 1)
          })], 2)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!item.audAgesEdit) ? _c('div') : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.displayFields('country')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.audCountryEdit) ? _c('div', {
            staticClass: "d-flex flex-row"
          }, [_c('v-select', {
            staticStyle: {
              "min-width": "120px",
              "max-width": "320px"
            },
            attrs: {
              "items": _vm.locationItems,
              "item-text": "name",
              "item-value": "name",
              "hide-details": "",
              "dense": "",
              "multiple": ""
            },
            on: {
              "change": function($event) {
                return _vm.checkSelectLimit(item, 'topCountries')
              }
            },
            model: {
              value: (item.topCountries),
              callback: function($$v) {
                _vm.$set(item, "topCountries", $$v)
              },
              expression: "item.topCountries"
            }
          }), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "success btn-edit-mth mr-1",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updatePairingCol(item, 'topCountries')
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "color": "white",
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
            staticStyle: {
              "margin-top": "7px"
            },
            attrs: {
              "color": "red btn-edit-mth",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                return _vm.changePairingColEdit('audCountryEdit', item, false)
              }
            }
          }, [_c('v-icon', {
            staticClass: "cursor-pointer",
            attrs: {
              "color": "white",
              "title": "Close",
              "x-small": ""
            }
          }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), ((!item.countries || (Array.isArray(item.countries) && item.countries.length === 0)) && (!item.topCountries || (Array.isArray(item.topCountries) && item.topCountries.length === 0))) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._e(), _vm._v(" "), (Array.isArray(item.countries) && Array.isArray(item.topCountries)) ? _c('div', [_c('v-menu', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: ((item.countries.length || item.topCountries.length) && !item.audCountryEdit),
              expression: "(item.countries.length || item.topCountries.length) && !item.audCountryEdit"
            }],
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: ((item.countries.length || item.topCountries.length) && !item.audCountryEdit),
                    expression: "(item.countries.length || item.topCountries.length) && !item.audCountryEdit"
                  }],
                  staticClass: "multi-select-more-btn ma-2",
                  attrs: {
                    "id": 'btnMore_' + parentIndex,
                    "x-small": "",
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [(item.topCountries && item.topCountries.length) ? _c('span', [_vm._v("\n                                    " + _vm._s(item.topCountries ? item.topCountries[0] : '-') + "\n                                  ")]) : _c('span', [_vm._v("\n                                    " + _vm._s(item.countries.length ? item.countries[0].name : '-') + "\n                                  ")])])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Aud. Country (Majority)")]), _vm._v(" "), (item.topCountryDisplay) ? _c('div', [_c('v-divider'), _vm._v(" "), _vm._l((item.topCountryDisplay), function(country, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(country.name))]), _vm._v(" "), (country.weight) ? _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((country.weight * 100).toFixed(2)) + "%)")]) : _vm._e()], 1)
          })], 2) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.countries), function(country, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(country.name))]), _vm._v(" "), (country.weight) ? _c('span', {
              staticClass: "more-percent"
            }, [_vm._v("(" + _vm._s((country.weight * 100).toFixed(2)) + "%)")]) : _vm._e()], 1)
          })], 2)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!item.audCountryEdit) ? _c('div') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('followers')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.followers ? _vm.formatNumber(item.followers) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('genderPercentage')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('div', {
            staticStyle: {
              "width": "75px"
            }
          }, [(item.audience_genders && item.audience_genders.length > 0) ? _c('PieChart', {
            attrs: {
              "name": ("genderPie" + parentIndex),
              "title": _vm.genderPie.title,
              "labels": _vm.genderPie.labels,
              "backgroundColors": _vm.genderPie.backgroundColors,
              "items": _vm.getGenderPieData(item.audience_genders),
              "options": _vm.genderPie.options,
              "width": _vm.genderPie.width,
              "height": _vm.genderPie.height
            }
          }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.displayFields('audienceCred')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "x-small": "",
              "color": item.audience_credibility_color,
              "text-color": "white"
            }
          }, [_vm._v(_vm._s(item.audience_credibility) + "%")]), _vm._v(" "), (item.message) ? _c('span', {
            staticClass: "text-danger"
          }, [_vm._v("(" + _vm._s(item.message) + ")")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgLikes')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_likes ? _vm.formatNumber(item.avg_likes) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgComments')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_comments ? _vm.formatNumber(item.avg_comments) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgReelsPlays')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_reels_plays ? _vm.formatNumber(item.avg_reels_plays) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgViews')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_views ? _vm.formatNumber(item.avg_views) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgSaves')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_saves ? _vm.formatNumber(item.avg_saves) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('avgShares')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.avg_shares ? _vm.formatNumber(item.avg_shares) : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('medianEngagementRate')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": "#CFD8DC",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s(item.median_engagement_rate ? ((item.median_engagement_rate) + "%") : '-'))])], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('infInterests')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(!item.infInterests || item.infInterests.length === 0) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._l((item.infInterests), function(interest, index) {
            return _c('v-chip', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (index === 0),
                expression: "index === 0"
              }],
              key: index,
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(interest.name))])
          }), _vm._v(" "), _c('v-menu', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (item.infInterests),
              expression: "item.infInterests"
            }],
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (item.infInterests && item.infInterests.length > 0),
                    expression: "item.infInterests && item.infInterests.length > 0"
                  }],
                  attrs: {
                    "id": 'btnMore_' + item.id,
                    "color": "secondary",
                    "x-small": "",
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_vm._v("\n                                More...\n                              ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Influencer Interests")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.infInterests), function(interest, index) {
            return _c('v-chip', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (index !== 0),
                expression: "index !== 0"
              }],
              key: index,
              staticClass: "ma-2",
              attrs: {
                "small": ""
              }
            }, [_vm._v(_vm._s(interest.name))])
          })], 2)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.displayFields('interests')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(!item.audience_interests || item.audience_interests.length === 0) ? _c('v-chip', {
            staticClass: "ma-2",
            staticStyle: {
              "text-transform": "capitalize"
            },
            attrs: {
              "color": "#ffffff",
              "x-small": "",
              "text-color": "black"
            }
          }, [_vm._v(_vm._s('-'))]) : _vm._l((item.audience_interests), function(interest, index) {
            return _c('v-chip', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (index === 0),
                expression: "index === 0"
              }],
              key: index,
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(interest.name))])
          }), _vm._v(" "), _c('v-menu', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (item.audience_interests),
              expression: "item.audience_interests"
            }],
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (item.audience_interests && item.audience_interests.length > 0),
                    expression: "item.audience_interests && item.audience_interests.length > 0"
                  }],
                  attrs: {
                    "id": 'btnMore_' + parentIndex,
                    "color": "secondary",
                    "x-small": "",
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_vm._v("\n                                  More...\n                                ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('div', [_vm._v("Audience Interests")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.audience_interests), function(interest, index) {
            return _c('div', {
              key: index,
              staticClass: "d-flex justify-space-between"
            }, [_c('v-chip', {
              staticClass: "ma-2",
              attrs: {
                "x-small": ""
              }
            }, [_vm._v(_vm._s(interest.name))]), _vm._v(" "), _c('span', {
              staticStyle: {}
            }, [_vm._v("(" + _vm._s((interest.weight * 100).toFixed(2)) + "%)")])], 1)
          })], 2)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.displayFields('engagement')) ? _c('td', {
            attrs: {
              "align": "center"
            }
          }, [(item.engagement_rate && item.engagement_rate !== '0.00') ? _c('span', [_vm._v(_vm._s(item.engagement_rate) + "%")]) : (item.engagement_rate === '0.00') ? _c('span', {
            staticClass: "caption"
          }, [_c('v-icon', {
            attrs: {
              "small": "",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "Hidden"
            }
          }, [_vm._v("mdi-eye-off")])], 1) : _c('span', [_vm._v("-")])]) : _vm._e()])
        })
      }
    }]),
    model: {
      value: (_vm.selectAllStatus),
      callback: function($$v) {
        _vm.selectAllStatus = $$v
      },
      expression: "selectAllStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2 text-right"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "color": "warning",
      "target": "_blank"
    },
    on: {
      "click": _vm.invokeSaveInfData
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)], 1)])], 1)], 1), _vm._v(" "), _c('influencer-list-modal', {
    attrs: {
      "value1": _vm.showInfluencerSearchResult,
      "result": _vm.influencerSearchResult,
      "influencers": _vm.selected,
      "keyword": _vm.currentKeywordSearch
    },
    on: {
      "input1": _vm.input1,
      "select": _vm.select
    },
    model: {
      value: (_vm.showInfluencerSearchResult),
      callback: function($$v) {
        _vm.showInfluencerSearchResult = $$v
      },
      expression: "showInfluencerSearchResult"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400"
    },
    model: {
      value: (_vm.reasonDialog),
      callback: function($$v) {
        _vm.reasonDialog = $$v
      },
      expression: "reasonDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Reason for elimination")]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.eliminationReason))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.reasonDialog = false
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('k-toast', {
    attrs: {
      "variant": _vm.toast.variant,
      "header": _vm.toast.header,
      "content": _vm.toast.content
    }
  }), _vm._v(" "), _c('settings-for-ai-modal', {
    attrs: {
      "value": _vm.settingAIDialog
    },
    on: {
      "paramsUpdated": function($event) {
        return _vm.paramsUpdated()
      }
    },
    model: {
      value: (_vm.settingAIDialog),
      callback: function($$v) {
        _vm.settingAIDialog = $$v
      },
      expression: "settingAIDialog"
    }
  }), _vm._v(" "), _c('settings-for-pairing', {
    attrs: {
      "value": _vm.updatePairingDialog,
      "view-only": _vm.viewOnly,
      "data": _vm.activePairingData
    },
    on: {
      "pairChanged": function($event) {
        return _vm.pairChanged()
      }
    },
    model: {
      value: (_vm.updatePairingDialog),
      callback: function($$v) {
        _vm.updatePairingDialog = $$v
      },
      expression: "updatePairingDialog"
    }
  }), _vm._v(" "), _c('price-multiplier-modal', {
    attrs: {
      "value": _vm.priceMultiplierDialog,
      "pairedInfluencer": _vm.priceMultiplierInfluencerData,
      "campaignData": _vm.campaign,
      "multiple": _vm.isMultipleDeliverables,
      "multipleInfs": _vm.actionSelected
    },
    on: {
      "clearSelected": function($event) {
        return _vm.clearActionSelected()
      },
      "savedFromPriceMultplier": function($event) {
        return _vm.pairChanged()
      }
    },
    model: {
      value: (_vm.priceMultiplierDialog),
      callback: function($$v) {
        _vm.priceMultiplierDialog = $$v
      },
      expression: "priceMultiplierDialog"
    }
  }), _vm._v(" "), _c('full-screen-progress', {
    attrs: {
      "show": _vm.bulkProgress.show,
      "isStatus": "true",
      "processing": _vm.bulkProgress.processing,
      "complete": _vm.bulkProgress.complete,
      "color": _vm.secondary
    }
  }), _vm._v(" "), _c('req-cogs-approval-modal', {
    attrs: {
      "value": _vm.reqApprovalDialog,
      "pairing": _vm.payoutEditPairing,
      "amount": _vm.reqAmt,
      "reasons": _vm.reqReasons,
      "budget": _vm.budget,
      "currentCOGS": _vm.measurement.budget,
      "cogsPercent": _vm.measurement.cogsPercentage
    },
    on: {
      "saved": function($event) {
        return _vm.getPairedInfluencers(_vm.campaign.id)
      }
    },
    model: {
      value: (_vm.reqApprovalDialog),
      callback: function($$v) {
        _vm.reqApprovalDialog = $$v
      },
      expression: "reqApprovalDialog"
    }
  }), _vm._v(" "), _c('payout-update-modal', {
    attrs: {
      "value": _vm.editPayoutDialog,
      "pairing": _vm.payoutEditPairing,
      "lockedPayout": _vm.lockedPayout,
      "cappedCOGS": _vm.budget,
      "currentCOGS": _vm.measurement.budget
    },
    on: {
      "budgetExceeded": _vm.openReqApprovalDialog,
      "refreshPairing": function($event) {
        return _vm.getPairedInfluencers(_vm.campaign.id)
      }
    },
    model: {
      value: (_vm.editPayoutDialog),
      callback: function($$v) {
        _vm.editPayoutDialog = $$v
      },
      expression: "editPayoutDialog"
    }
  }), _vm._v(" "), _c('pairing-elimination-edit-modal', {
    attrs: {
      "campaingData": _vm.campaingDataForElimination
    },
    on: {
      "invokeSendToClient": _vm.invokeSendToClient
    },
    model: {
      value: (_vm.eliminationDialog),
      callback: function($$v) {
        _vm.eliminationDialog = $$v
      },
      expression: "eliminationDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77514770"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/InfluencerLists/ViewInfluencerListModal.vue
// module id = 2205
// module chunks = 0